import Vue from 'vue'
import { Search, Uploader, overlay, field, swipe, card, swipeCell, button, loading, Toast, sticky, Dialog, popup, ImagePreview, PullRefresh, List } from "vant";
Vue.use(Search);
Vue.use(Uploader);
Vue.use(overlay);
Vue.use(field);
Vue.use(swipe);
Vue.use(card);
Vue.use(swipeCell);
Vue.use(button);
Vue.use(loading);
Vue.use(Toast);
Vue.use(sticky);
Vue.use(Dialog);
Vue.use(popup);
Vue.use(ImagePreview);
Vue.use(PullRefresh);
Vue.use(List);